import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_CARRIERS,
  GET_CARRIERS_ALL_COMBO,
GET_USERS, GET_USER_TYPES, SAVE_USERS
} from "./actionTypes"
import {
  getCarriersAllComboFail,
  getCarriersAllComboSuccess,
  getCarriersFail,
  getCarriersSuccess,
} from "./actions"
import { getAllCarriersCombo, getCarriers,  } from "./Service"



function* fetchCarriers() {
  try {
    const response = yield call(getCarriers)
    yield put(getCarriersSuccess(response))
  } catch (error) {
    yield put(getCarriersFail(error))
  }
}

function* fetchAllCarriersCombo() {
  try {
    const response = yield call(getAllCarriersCombo)
    yield put(getCarriersAllComboSuccess(response))
  } catch (error) {
    yield put(getCarriersAllComboFail(error))
  }


}

function* carriersSaga() {
  yield takeEvery(GET_CARRIERS, fetchCarriers)
  yield takeEvery(GET_CARRIERS_ALL_COMBO, fetchAllCarriersCombo)
}

export default carriersSaga
